import { useStore } from '@stores';
import { useEffect } from 'react';

export const useVehicleByVin = (vin?: string | null) => {
  const { vehicleStore } = useStore();
  const { vehicle } = vehicleStore;

  useEffect(() => {
    if (vin) {
      vehicleStore.getByVin(vin);
    }
  }, [vehicleStore, vin]);

  return vehicle;
};

/**
 * The vehicle of an invoice. The store's vehicle is shared, so with no VIN to load - or until it has
 * loaded - it still holds the last vehicle viewed, which must not be shown as this invoice's.
 */
export const useInvoiceVehicle = (vin?: string | null) => {
  const vehicle = useVehicleByVin(vin);
  const wanted = vin?.trim().toUpperCase();

  return wanted && vehicle?.combinedVin?.trim().toUpperCase() === wanted ? vehicle : undefined;
};
